import { Outlet } from "react-router-dom";
import { NavbarSubHome } from "../../components";
import styled from "styled-components";

const AuthLayout = () => {
  return (
    <>
    <NavbarContainerWrapper>
      <NavbarSubHome/>
    </NavbarContainerWrapper>     
        
      <Outlet/>
    </>
  )
}

export default AuthLayout

export const NavbarContainerWrapper = styled.div`
  padding-top: 60px;
`;